import React from "react";
import { Canvas } from "@react-three/fiber";
import Cube from "./Cube";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Canvas
        camera={{ position: [0, 0, 5], fov: 75 }}
        shadows
        gl={{ antialias: true }}
      >
        <Cube />
      </Canvas>
      
      <div className="overlay">
        <h1>3D Cube with React Three Fiber</h1>
        <p>Drag to rotate • Scroll to zoom</p>
      </div>
    </div>
  );
}

export default App;